import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

export const useSpeech = (onResult) => {
    const [isListening, setIsListening] = useState(false);
    const [recognition, setRecognition] = useState(null);

    useEffect(() => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

        if (SpeechRecognition) {
            const recog = new SpeechRecognition();
            recog.continuous = false; // 한 문장을 말하고 쉬면 자동으로 종료
            recog.interimResults = true; // 말하는 도중에도 실시간으로 텍스트 보여주기
            recog.lang = 'ko-KR';

            recog.onresult = (event) => {
                let interimTranscript = '';
                for (let i = event.resultIndex; i < event.results.length; ++i) {
                    if (event.results[i].isFinal) {
                        onResult(event.results[i][0].transcript); // 최종 결과
                    } else {
                        interimTranscript += event.results[i][0].transcript;
                        onResult(interimTranscript); // 임시 결과
                    }
                }
            };

            recog.onerror = () => setIsListening(false);
            recog.onend = () => setIsListening(false);

            setRecognition(recog);
        }
    }, [onResult]);

    const toggleListening = () => {
        if (isListening) {
            recognition.stop();
        } else {
            if (recognition) {
                recognition.start();
                setIsListening(true);
            } else {
                toast.warn('현재 사용 중인 브라우저에서는 음성 인식을 지원하지 않습니다. Chrome을 사용해 주세요.');
            }
        }
    };

    return { isListening, toggleListening };
};
